import React from "react";
import styled from "styled-components";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Library from "../components/mainLibrary/Library";
import HeaderSvg from "../components/HeaderSvg";

const MainLibrary = () => {
  return (
    <AppWrapper>
      <HeaderSvg />
      <Header />
      <Library />
      <Footer />
    </AppWrapper>
  );
};

const AppWrapper = styled.div``;
export default MainLibrary;
